import React, { ChangeEvent, useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { fetchData, viewdata, adddata, UploadImageData, doceditdata, doceditdatanoimage, deletedocdata } from '../reduxactions/donorrsactions/DDocumentsActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { RootState } from '../reducers';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';


export const DonorDocuments = () => {

    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()

    const data = useSelector((state: RootState) => state.ddocument.data);
    const dataview = useSelector((state: RootState) => state.ddocument.dataview);
    const adddatacheck = useSelector((state: RootState) => state.ddocument.adddata);


    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(uid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])


    //To assign data 
    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
        setAdddocument(false);
        SetEdit(false);
    }
    //To assign data 
    const viewupload = (rowData: any) => {

        assignData.current = { DocID: rowData.DocID }
        setfield(true);
        fetchDataAsyncdialog();
    };
    const assignData = useRef({ DocID: '' })
    const fetchDataAsyncdialog = async () => {
        try {
            const { DocID } = assignData.current;
            console.log("DocID", DocID)
            await dispatch(viewdata(DocID) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };
    //To add property holder
    const [Adddocument, setAdddocument] = useState(false);
    const [document, setDocument] = useState<string>('');
    //const [date, setDate] = useState<Date | null>(new Date());
    const [date, setDate] = useState<Date | null>(null);
    const [fileName, setFileName] = useState('');


    const [file, setFile] = useState<string>('');


    //To add Adddocument dispatching data to ts
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file)
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const adddatafile = useSelector((state: RootState) => state.ddocument.imgdata);
    console.log("adddatafile", adddatafile)

    const adduploads = async () => {
        const filename = adddatafile.filename;
        await dispatch(adddata(document, date, filename, uid) as any);
        setAdddocument(false);
        fetchDataAsync();
        toast.current.show({ severity: 'success', summary: 'Document Added successfully', detail: adddatacheck, life: 3000 })
    };

    const [Editdoc, SetEdit] = useState(false);

    const [editData, setEditData] = useState({
        CreteDate: '',
        doc_name: '',
        expiry_date: '',
        id: '',
        adddatafile: '' as any,
        UserID: ''
    });

    //To dispatch edit data fieldofficer.ts
    const EditAdminManager = async () => {
        // if (adddatafile && adddatafile.length >0) {
        const filename = adddatafile.filename;
        if (adddatafile && adddatafile.filename) {
            console.log("Add file only called")
            const { doc_name, expiry_date, adddatafile, id, UserID } = editData;
            await dispatch(doceditdata(doc_name, expiry_date, filename, parseInt(id, 10), UserID) as any);
        } else {
            console.log("Without file only called")
            const { doc_name, expiry_date, id, UserID } = editData;
            await dispatch(doceditdatanoimage(doc_name, expiry_date, parseInt(id, 10), UserID) as any);
        }
        fetchDataAsync();
        SetEdit(false);
        toast.current.show({ severity: 'success', summary: 'Document Updated Successfully', detail: editdatasmsg, life: 3000 })

    }
    const editdatasmsg = useSelector((state: RootState) => state.ddocument.editdat);
    const editupload = (rowData: any) => {
        setEditData({
            CreteDate: rowData.CreteDate,
            doc_name: rowData.doc_name,
            expiry_date: rowData.expiry_date,
            id: rowData.DocID,
            adddatafile: adddatafile,
            UserID: rowData.UserID
        });
        SetEdit(true);
    }

    const [deleteConfirmation, setDeleteConfirmation] = useState(false)
    //To delete data 
    const [delData, setDeleteData] = useState({
        DocID: '',
    });
    //data from table 
    const Delete = (rowData: any) => {
        setDeleteData({
            DocID: rowData.DocID,
        });
        // idRef.current = rowData.id;
        setDeleteConfirmation(true);
    };
    //To dispatch data to delete in fieldofficeraction.ts
    const confirmDelete = async () => {
        const { DocID } = delData;
        try {
            await dispatch(deletedocdata(DocID) as any);

            setDeleteConfirmation(false);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
        toast.current.show({ severity: 'success', summary: 'Deleted Successfully', detail: deldata, life: 3000 })
        fetchDataAsync();

    };
    //To close dialog box
    const cancelDelete = () => {
        setDeleteConfirmation(false);
    };
    const deldata = useSelector((state: RootState) => state.ddocument.deletedata)
    const toast = useRef(deldata);
    const toast1 = useRef(editdatasmsg);
    const toast2 = useRef(adddatacheck);

    const handleChange = (e: ChangeEvent<any>, { value }: { value: Date }) => {
        setDate(value);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donor-documents.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Documents</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{
                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Documents</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* <section className="content"> */}
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card flex flex-wrap justify-content-end">

                                        {/* <Button label="Add Uploads" severity="info" data-testid="add-uploads-btn" onClick={() => setAdddocument(true)} /> */}
                                        <GFNButton label="Add Uploads" data-testid="add-uploads-btn" onClick={() => setAdddocument(true)} buttonType="primary" />
                                    </div>

                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>
                                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="CreteDate" sortable header="Uploaded Date"></Column>
                                        <Column field="expiry_date" sortable header="Expiry Date"></Column>
                                        <Column field="doc_name" sortable header="Title"></Column>
                                        <Column header="Option" body={(rowData, { rowIndex }) => (
                                            <div>
                                                {/* <Button icon="pi pi-eye" tooltip="View" data-testid={`view-btn${rowIndex}`} className="mr-4" onClick={(handleFileUpload) => viewupload(rowData)} style={{ backgroundColor: 'white', color: 'blue', borderRadius: '30px', width: '2rem', height: '2rem' }} />
                                                <Button className='mr-4' tooltip="Edit" data-testid={`edit-btn${rowIndex}`} severity="info" rounded outlined icon="pi pi-pencil" onClick={(handleFileUpload) => editupload(rowData)}
                                                    style={{ color: 'mediumseagreen', width: '2rem', height: '2rem' }} />
                                                <Button icon="pi pi-trash" data-testid={`delete-btn${rowIndex}`} rounded outlined className="p-button-danger mr-1" aria-label="Delete" tooltip="Delete" onClick={() => Delete(rowData)} style={{ width: '2rem', height: '2rem' }} /> */}
                                                <GFNButton icon="pi pi-eye" tooltip="View" data-testid={`view-btn${rowIndex}`} className="mr-3" onClick={(handleFileUpload) => viewupload(rowData)} buttonType="primary" />
                                                <GFNButton className='mr-3' tooltip="Edit" data-testid={`edit-btn${rowIndex}`} icon="pi pi-pencil" rounded outlined buttonType="success" onClick={(handleFileUpload) => editupload(rowData)} />
                                                <GFNButton icon="pi pi-trash" data-testid={`delete-btn${rowIndex}`} rounded outlined buttonType="danger" aria-label="Delete" tooltip="Delete" onClick={() => Delete(rowData)} />
                                            </div>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Panel>
                        {/* </section> */}


                        <Dialog header="View" data-testid="view-dialog" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>

                            <div className="modal-body">
                                {dataview.map((response: any, index: number) =>
                                    <div key={index}>
                                        {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                        {response.filetype !== 'photo' &&
                                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                        }
                                        {response.filetype === 'pdf' && (
                                            <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                Open PDF in New Tab
                                            </a>
                                        )}
                                    </div>

                                )}
                            </div>
                            <Button label="Close" className="ml-2" severity="secondary" data-testid="view-close-btn" onClick={cancelfield} />
                        </Dialog>

                        <Dialog header="Upload Document" data-testid="add-dialog" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >
                            <div className='row'>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="name"   >Document Title:</label>
                                        </div>
                                        <div className="col md-3" >
                                            <InputText id="name" style={{ width: '15vw' }} data-testid="doc-input" name="document" placeholder='Document-title' onChange={(e) => setDocument(e.target.value)} />
                                        </div>
                                        <div className="col-2" ></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="year" >Expiry Date:</label>
                                        </div>
                                        <div className="col md-3" >
                                            {/* <Calendar
                                                id="expdate"
                                                style={{ width: '15vw' }}
                                                name="date"
                                                placeholder='dd-mm-yyyy'
                                                onChange={(e) => e.value && setDate(e.value)}
                                            /> */}
                                            <Calendar
                                                id="expdate"
                                                style={{ width: '15vw' }}
                                                name="date"
                                                data-testid="expirey-date"
                                                placeholder="dd-mm-yyyy"
                                                value={date}
                                                onChange={(e) => setDate(e.value as Date)}
                                                dateFormat="dd-mm-yy"
                                            />

                                        </div>
                                    </div>
                                </div>
                                {/* <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="file" >Select File:</label>
                                        </div>
                                        <div className="col-3" >
                                            <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row'>
                                    <div className="grid pt-3">

                                        <div className="col-3">
                                            <label htmlFor="file">Select File:</label>
                                        </div>

                                        <div className="col-3">
                                            <FileUpload
                                                mode="basic"
                                                id="fileToUpload"
                                                data-testid="add-upload-file"
                                                name="fileToUpload"
                                                customUpload
                                                accept="image/*"
                                                maxFileSize={1000000}
                                                uploadHandler={UploadManagerImage}
                                                auto
                                                onSelect={(e) => {
                                                    setFileName(e.files[0].name);
                                                }}
                                            />

                                            {fileName && (
                                                <div className="mt-2">
                                                    {fileName}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <br></br>
                            {/* <Button label="Close" className="ml-2" data-testid="add-dialog-close-btn" severity="secondary" onClick={cancelfield} /> */}
                            {/* <Button label="ADD" severity="" onClick={adduploads} data-testid="add-dialog-add-btn" style={{ float: 'right', marginRight: "30px" }} /> */}
                            <GFNButton label="Close" className="ml-2" data-testid="add-dialog-close-btn" onClick={cancelfield} buttonType="secondary" />
                            <GFNButton label="ADD" onClick={adduploads} data-testid="add-dialog-add-btn" style={{ float: 'right', marginRight: "30px" }} buttonType="primary" />
                        </Dialog>


                        {/* </Dialog > */}
                        <Dialog header="Upload Document" visible={Editdoc} data-testid="edit-dialog" style={{ width: '30vw', height: '40' }} onHide={() => SetEdit(false)} >
                            <div className='row'>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="name"   >Document Title:</label>
                                        </div>
                                        <div className="col md-3" >
                                            <InputText id="name" style={{ width: '15vw' }} data-testid="edit-document-input" name="Doctitle" onChange={(e) => setEditData({ ...editData, doc_name: e.target.value })} value={editData.doc_name} />
                                        </div>
                                        <div className="col-2" ></div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="year" >Expiry Date:</label>
                                        </div>
                                        <div className="col md-3" >
                                            {/* <Calendar id="expdate" value={editData.expiry_date} style={{ width: '15vw' }} name="date" placeholder='dd-mm-yyyy' onChange={(e) => setEditData({ ...editData, expiry_date: e.value as Date | null })}  /> */}
                                            <InputText id="expdate" type="date" style={{ width: '15vw' }} data-testid="edit-document-date" name="date" onChange={(e) => setEditData({ ...editData, expiry_date: e.target.value })} value={editData.expiry_date} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="file" >Select File:</label>
                                        </div>
                                        <div className="col-3" >
                                            <FileUpload mode="basic" id="fileToUpload" data-testid="edit-upload-file" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <Button label="Close" className="ml-2" severity="secondary" data-testid="edit-close-btn" onClick={cancelfield} />
                            <Button label="Update" className="p-button-success p-button-outlined" data-testid="edit-update-btn" onClick={EditAdminManager} style={{ float: 'right', backgroundColor: 'blueviolet', color: 'white' }} />
                        </Dialog>
                        < Dialog header="Confirm Delete" style={{ width: '30vw' }} data-testid="delete-dialog" visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                            <div>Are you sure you want to delete this item?</div>
                            {/* <Button label="Delete" icon="pi pi-check" data-testid="delete-close-btn" className='mr-3 p-button-raised' onClick={confirmDelete} />
                            <Button label="Close" icon="pi pi-times" data-testid="delete-delete-btn" onClick={cancelDelete} className="mr-3 p-button-secondary" /> */}
                            <GFNButton label="Delete" icon="pi pi-check" data-testid="delete-close-btn" className='mr-3 mt-4' onClick={confirmDelete} buttonType="danger" />
                            <GFNButton label="Close" icon="pi pi-times" data-testid="delete-delete-btn" onClick={cancelDelete} className="mr-3 mt-4" buttonType="secondary" />
                        </Dialog >
                        <Toast ref={toast} >
                            <Message severity="success" content={deldata} />
                        </Toast>
                        <Toast ref={toast1} >
                            <Message severity="success" content={editdatasmsg} />
                        </Toast>
                        <Toast ref={toast2} >
                            <Message severity="success" content={adddatacheck} />
                        </Toast>

                    </div>
                </div>
            </div>
        </div>
    )
}  
